import * as React from 'react';
import ItemTypes from './ItemTypes';
import Nodes from './Node';
import Name from './Name';
import NodeActionButtons from './NodeActionButtons';
import { Translate } from '../../../shared/LanguageService';
import { useDrag, useDrop } from 'react-dnd';

let canDropItem = false;

function Node(props) {
    const {
        item,
        move,
        onToggle,
        onClick,
        onAdd,
        canCreate,
        onDelete,
        canMove,
        canDelete,
        showLogs,
        canRestore,
        onRestore
    } = props;

    const [isHover, setIsHover] = React.useState(false);

    const onMouseOver = () => {
        setIsHover((hover) => true);
    };

    const onMouseOut = () => {
        setIsHover((hover) => false);
    };

    function attachRef(el) {
        drag(el);
        drop(el);
    }

    const [{}, drag] = useDrag(() => ({
        type: 'node',
        item,
        canDrag() {
            if (canMove === false) {
                return false;
            }

            switch (item.type) {
                case ItemTypes.Chain.name:
                    return ItemTypes.Chain.canDrag;
                case ItemTypes.FirmGroup.name:
                    return ItemTypes.FirmGroup.canDrag;
                case ItemTypes.Firm.name:
                    return ItemTypes.Firm.canDrag;
                case ItemTypes.Agent.name:
                    return ItemTypes.Agent.canDrag;
                default:
                    return false;
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    }));

    const [{ canDrop, isOver }, drop] = useDrop(() => ({
        accept: 'node',
        drop: (item, monitor) => {
            if (monitor.didDrop() || !monitor.canDrop() || !canDropItem) {
                return;
            }

            const { item: target, move } = props;
            move(item, target);
            return { moved: true };
        },
        canDrop(item, monitor: any) {
            if (
                props.item === item ||
                item.parentId === props.item.id ||
                checkChildren(item.children, props.item.id)
            ) {
                return false;
            }

            if (props.item.availableTypes) {
                return props.item.availableTypes.some((type: any) => type.name === item.type);
            }

            return false;

            function checkChildren(nodes: any[], id: number) {
                if (!nodes || nodes.length === 0) {
                    return false;
                }

                let exists = nodes.some((item: any) => item.id === id);

                if (exists) {
                    return true;
                }

                exists = nodes.some((item: any) => checkChildren(item.children, id));

                return exists;
            }
        },
        hover(item, monitor: any) {
            const canDrop = monitor.canDrop({ shallow: true });
            if (!canDrop) {
                return;
            }

            const { item: target, move } = props;

            if (item.name === target.name) {
                return;
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver({ shallow: true }),
            canDrop: monitor.canDrop()
        })
    }));

    let overStyle: any = {};

    if (isOver) {
        overStyle.borderColor = '#ddd';
        overStyle.background = '#eee';

        if (canDrop) {
            overStyle.color = '#00ff00';
            canDropItem = true;
        } else {
            overStyle.color = '#ff0000';
            canDropItem = false;
        }
    }

    let toggleIcon = item.toggle === true ? 'keyboard_arrow_down' : 'keyboard_arrow_right';

    let type: any = ItemTypes.Chain;
    if (item.type === ItemTypes.FirmGroup.name) {
        type = ItemTypes.FirmGroup;
    } else if (item.type === ItemTypes.Firm.name) {
        type = ItemTypes.Firm;
    } else if (item.type === ItemTypes.Agent.name) {
        type = ItemTypes.Agent;
    }

    let toggleClass =
        type.canToggle && (item.hasChildren || (item.children && item.children.length > 0))
            ? 'material-icons'
            : 'material-icons empty';

    let treeClass = isHover ? 'tree-node active' : 'tree-node';

    return (
        <li>
            <span
                ref={attachRef}
                style={overStyle}
                className={`${treeClass} ${item.isRemoved ? 'removed-node' : ''}`}
                onMouseOver={onMouseOver}
                onMouseOut={onMouseOut}
            >
                <span>
                    {type === ItemTypes.Chain ? (
                        ''
                    ) : (
                        <i className="material-icons drag">drag_handle</i>
                    )}
                    <i
                        onClick={() => {
                            toggleClass && onToggle(item);
                        }}
                        className={toggleClass}
                    >
                        {toggleIcon}
                    </i>
                    <span className={type.label}>{Translate(type.translation)}</span>
                    <Name item={item} onClick={onClick} />
                </span>

                <NodeActionButtons
                    item={item}
                    onRestore={onRestore}
                    canRestore={canRestore}
                    onClick={onAdd}
                    canCreate={canCreate}
                    showLogs={showLogs}
                    onDelete={onDelete}
                    canDelete={canDelete}
                />
            </span>

            {item.toggle && item.show && (
                <ul>
                    {item.children &&
                        item.children.map((child: any) => {
                            if (child.show) {
                                return (
                                    <Nodes
                                        key={child.id + 'node'}
                                        item={child}
                                        move={move}
                                        onToggle={onToggle}
                                        onClick={onClick}
                                        onAdd={onAdd}
                                        canCreate={canCreate}
                                        canMove={canMove}
                                        onDelete={onDelete}
                                        canDelete={canDelete}
                                        showLogs={showLogs}
                                        canRestore={canRestore}
                                        onRestore={onRestore}
                                    />
                                );
                            }
                        })}
                </ul>
            )}
        </li>
    );
}

export default Node;
